import HomePage from "./pages/HomePage";

const App = (): JSX.Element => {
	return <HomePage />;
};

export default App;
